import { render } from "./MutipleForm.vue?vue&type=template&id=eabaeed4&scoped=true&ts=true"
import script from "./MutipleForm.vue?vue&type=script&lang=ts"
export * from "./MutipleForm.vue?vue&type=script&lang=ts"

import "./MutipleForm.vue?vue&type=style&index=0&id=eabaeed4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabaeed4"]])

export default __exports__